module.exports = __webpack_public_path__ + "img/monitor-mobile.2dc4b9f3.svg";